var _rect, _circle, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1209 1210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 25.7197,
    width: 1158,
    height: 1158,
    rx: 34.5,
    fill: "#F1C40F",
    stroke: "white",
    strokeWidth: 51
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 604.5,
    cy: 604.72,
    r: 87.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 254,
    width: 45,
    height: 240,
    rx: 22.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 240,
    rx: 22.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 247 448)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 240,
    rx: 22.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 727 448)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 477.88,
    rx: 22.5,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 753.636 434.482)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 753.636,
    y: 782.389,
    width: 45,
    height: 477.88,
    rx: 22.5,
    transform: "rotate(-45 753.636 782.389)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 91.6357,
    y: 128.389,
    width: 45,
    height: 477.88,
    rx: 22.5,
    transform: "rotate(-45 91.6357 128.389)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 477.88,
    rx: 22.5,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 91.6357 1085.48)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 240,
    rx: 22.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 247 722)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 240,
    rx: 22.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 727 722)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 727,
    y: 254,
    width: 45,
    height: 240,
    rx: 22.5,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 725,
    y: 722,
    width: 45,
    height: 240,
    rx: 22.5,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 722,
    width: 45,
    height: 240,
    rx: 22.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.ee97c8e22b340e37a4baa325c0550f19.svg";
export { ForwardRef as ReactComponent };